import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './../common/SafeIcon';
import { colord } from 'colord';
import { motion, AnimatePresence } from 'framer-motion';

const NavTabs = ({ color }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const tabs = [
    { id: 'intelligence', label: 'Intelligence', icon: FiIcons.FiCpu },
    { id: 'workspace', label: 'Workspace', icon: FiIcons.FiGrid },
    { id: 'personality', label: 'Personality', icon: FiIcons.FiUserCheck },
    { id: 'discovery', label: 'Discovery', icon: FiIcons.FiCompass },
    { id: 'theory', label: 'Theory', icon: FiIcons.FiBookOpen },
    { id: 'insights', label: 'Insights', icon: FiIcons.FiBarChart2 }
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: elementPosition, behavior: 'smooth' });
      setIsMenuOpen(false); // Close mobile menu after navigation
    }
  };

  const accentColor = colord(color).alpha(0.4).toRgbString();

  return (
    <>
      {/* Desktop Navigation */}
      <nav className="hidden lg:block mb-10 sm:mb-12 md:mb-16 lg:mb-20 xl:mb-24">
        <div className="flex items-center gap-1.5 sm:gap-2 md:gap-3 p-2 sm:p-3 md:p-4 glass-panel rounded-xl sm:rounded-2xl md:rounded-3xl shadow-xl">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => scrollToSection(tab.id)}
              className="flex-1 flex items-center justify-center gap-2 sm:gap-3 md:gap-4 px-3 sm:px-5 md:px-7 lg:px-9 py-2.5 sm:py-3 md:py-3.5 lg:py-4 xl:py-5 rounded-lg sm:rounded-xl md:rounded-2xl text-[9px] sm:text-[10px] md:text-xs lg:text-sm font-light uppercase tracking-[0.08em] sm:tracking-[0.1em] text-white/50 hover:text-white hover:bg-white/[0.08] transition-all group whitespace-nowrap font-display active:scale-95"
              style={{ '--hover-color': accentColor }}
            >
              <SafeIcon icon={tab.icon} className="text-sm sm:text-base md:text-lg group-hover:scale-110 transition-transform flex-shrink-0" />
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      </nav>

      {/* Mobile Navigation */}
      <nav className="lg:hidden mb-6 sm:mb-8 md:mb-10">
        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="w-full flex items-center justify-between p-4 glass-panel rounded-xl shadow-xl"
        >
          <div className="flex items-center gap-3">
            <SafeIcon icon={FiIcons.FiMenu} className="text-white text-lg" />
            <span className="text-xs sm:text-sm font-light uppercase tracking-wider text-white font-display">
              Navigation Menu
            </span>
          </div>
          <SafeIcon 
            icon={isMenuOpen ? FiIcons.FiChevronUp : FiIcons.FiChevronDown} 
            className="text-white/60 text-lg transition-transform"
          />
        </button>

        {/* Mobile Dropdown Menu */}
        <AnimatePresence>
          {isMenuOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.2 }}
              className="overflow-hidden mt-2"
            >
              <div className="glass-panel rounded-xl shadow-xl p-2">
                {tabs.map((tab, idx) => (
                  <button
                    key={tab.id}
                    onClick={() => scrollToSection(tab.id)}
                    className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-white/60 hover:text-white hover:bg-white/[0.08] transition-all group"
                  >
                    <SafeIcon icon={tab.icon} className="text-base group-hover:scale-110 transition-transform flex-shrink-0" />
                    <span className="text-xs font-light uppercase tracking-wider font-display">
                      {tab.label}
                    </span>
                  </button>
                ))}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </nav>
    </>
  );
};

export default NavTabs;